<div class="d-flex gap-1 flex-wrap">
  <span
    *ngFor="let weekday of weekdaysArray; trackBy: trackByWeekday"
    class="d-block fw-medium text-capitalize"
    [class.text-dark-gray]="candidateAvailability && !candidateAvailability[weekday[1]]"
    [ngbTooltip]="
      (candidateAvailability && candidateAvailability[weekday[1]]
        ? ('tooltip.willingnessFor' | translate)
        : ('tooltip.noWillingnessFor' | translate)) + ('tooltip.weekDays.' + weekday[0] | translate)
    "
  >
    {{ weekday[0] }}
  </span>
</div>
